"use client"

import { Captions } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `CaptionsIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const CaptionsIcon = component(Icon)({ as: Captions })
